module.exports = __webpack_public_path__ + "img/stock1.ba1d173a.png";